import { Controller } from "@hotwired/stimulus"
import Sortable from "sortablejs"
import { track } from "../lib/mixpanel"

const LOCKED = ["rag", "project"]
const DEFAULTS = [
  "rag", "project", "phase", "status", "budget", "spent", "variance_dollars",
  "schedule", "overdue_items", "last_activity", "pm"
]

export default class extends Controller {
  static targets = ["list", "item", "checkbox"]

  connect() {
    this._sortable = Sortable.create(this.listTarget, {
      handle: "[data-drag-handle]",
      filter: "[data-locked='true']",
      onMove: (evt) => evt.related?.dataset?.locked !== "true",
      animation: 150
    })
  }

  disconnect() {
    this._sortable?.destroy()
  }

  resetDefaults() {
    this._applyOrdering(DEFAULTS)
    this.checkboxTargets.forEach(cb => {
      cb.checked = DEFAULTS.includes(cb.dataset.key) || LOCKED.includes(cb.dataset.key)
    })
  }

  apply() {
    const orderedKeys = this.itemTargets.map(el => el.dataset.key)
    const visible = orderedKeys.filter(key => {
      if (LOCKED.includes(key)) return true
      const cb = this.checkboxTargets.find(c => c.dataset.key === key)
      return cb && cb.checked
    })

    const url = new URL(window.location.href)
    url.searchParams.set("cols", visible.join(","))
    url.searchParams.set("col_order", visible.join(","))
    // Drop the preset id so the saved preset's columns don't override the manual edit.
    url.searchParams.delete("preset")

    this.dispatch("close")

    const frame = document.getElementById("portfolio-dashboard-content")
    if (frame) {
      frame.src = url.toString()
    } else {
      window.location.href = url.toString()
    }

    track("Portfolio Columns Customized", { column_count: visible.length })
  }

  _applyOrdering(keys) {
    const items = Array.from(this.listTarget.children)
    const byKey = new Map(items.map(el => [el.dataset.key, el]))
    keys.forEach(key => {
      const el = byKey.get(key)
      if (el) this.listTarget.appendChild(el)
      byKey.delete(key)
    })
    byKey.forEach(el => this.listTarget.appendChild(el))
  }
}
